import { camel2title } from './formatters'

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex
}

var React = _interopDefault(require('react'))

function styleInject(css, ref) {
  if (ref === void 0) ref = {}
  var insertAt = ref.insertAt

  if (!css || typeof document === 'undefined') {
    return
  }

  var head = document.head || document.getElementsByTagName('head')[0]
  var style = document.createElement('style')
  style.type = 'text/css'

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild)
    } else {
      head.appendChild(style)
    }
  } else {
    head.appendChild(style)
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css
  } else {
    style.appendChild(document.createTextNode(css))
  }
}

var css = ''
styleInject(css)

var _typeof =
  typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
    ? function (obj) {
        return typeof obj
      }
    : function (obj) {
        return obj &&
          typeof Symbol === 'function' &&
          obj.constructor === Symbol &&
          obj !== Symbol.prototype
          ? 'symbol'
          : typeof obj
      }

export const JSONToHTMLTable = (props) => {
  var data = props.data,
    wrapperClassName = props.wrapperClassName,
    tableClassName = props.tableClassName

  return React.createElement(
    'div',
    { className: wrapperClassName },
    React.createElement(
      'table',
      { className: tableClassName },
      React.createElement(
        'tbody',
        null,
        Object.keys(data).map(function (k) {
          return React.createElement(
            'tr',
            { key: k },
            !Array.isArray(data) &&
              React.createElement(
                'td',
                null,
                camel2title(k.replace(/_/g, ' '))
              ),
            (function () {
              if (data[k] && _typeof(data[k]) === 'object') {
                return React.createElement(
                  'td',
                  null,
                  React.createElement(JSONToHTMLTable, {
                    data: data[k],
                    tableClassName: tableClassName,
                  })
                )
              }
              return React.createElement(
                'td',
                null,
                React.createElement('span', {
                  dangerouslySetInnerHTML: { __html: data[k] },
                })
              )
            })()
          )
        })
      )
    )
  )
}
